/**
 * Created by eliana.centamore on 08/02/2017.
 */
"use strict";

var App = require("CommonClientServer/Base/app");
var SELF;


var IbanValidator = function () {
    SELF = this;
    this.api = App.api;

    this.feedbackButton = $("#feedback_send");
    this.attachEvent();
};


IbanValidator.prototype.attachEvent = function () {
    SELF.feedbackButton.click(this.sendFeedback);
};


IbanValidator.prototype.sendFeedback = function () {
    var url = App.baseUrl + "/" + window.Swiftref.lang + "/sepaio/sepabicfromiban/sendfeedback";
    var data = {};

    if (SELF.validateInput()) {
        //Build request
        $('#feedbackModal form').serializeArray().forEach(function (form) {
            if (form.value) {
                data[form.name] = form.value;
                data.feedback_iban = $('#feedback_iban').val().trim();
            }
        });

        //Append loading
        $('#feedbackModal form button#feedback_send').append('<img src="' + App.baseUrl + '/imgs/sepaio/sepabicfromiban/wait_small_blue.gif" height="20" width="20">');

        //Make request
        $.post({
            url: url,
            data: {data: data}
        }).done(function (response) {
            $("#feedback_success").removeClass('hidden');
            $("#feedback_footer").remove();
            $("#feedbackModal form button img").remove();
        }).fail(function (error) {
            var errors = error.responseJSON;
            $("#feedbackModal #feedback_error").html("");
            $.each(errors, function (key, value) {
                $("#feedbackModal #feedback_error").append('<b>' + value + '</b><br>');
            });
            $('#feedback_send').remove();
            $("#feedbackModal form button img").remove();
        });
    }
};


IbanValidator.prototype.validateInput = function () {
    $("#feedbackModal #feedback_error").html("");

    $('#feedbackModal form input').removeClass("error");

    if ($('#feedback_first_last_name').val().trim() === '') {
        $("#feedbackModal #feedback_error").append('<b>' + window.Swiftref.texts.first_lastname_empty + '</b><br>');
        return;
    }
    if ($('#feedback_email').val().trim() === '') {
        $("#feedbackModal #feedback_error").append('<b>' + window.Swiftref.texts.email_empty + '</b><br>');
        return;
    }
    if ($('#feedback_message').val().trim() === '') {
        $("#feedbackModal #feedback_error").append('<b>' + window.Swiftref.texts.message_empty + '</b><br>');
        return;
    }

    if ($('#feedback_captcha').val().trim() === '') {
        $("#feedbackModal #feedback_error").append('<b>' + window.Swiftref.texts.captcha_empty_error + '</b><br>');
        return;
    }
    return true;
};


module.exports = IbanValidator;
